/* DeleteImageRenderer.js */

"use strict";
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;
const CheckboxControl = require("@gluenetworks/steve_ui_core").Control.Boolean.InputCheckbox;

class DeleteImageRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("delete-image-veil-gl");
        this._rootElem.component = this._model;

        this._titleComponent = document.createElement("h2");
        this._titleComponent.innerText = this._model.titleText;

        this._messageContainer = document.createElement("div");
        this._messageContainer.classList.add("delete-image-message");

        const imageName = this._model.entity.description || this._model.entity.name || "this image";
        const platformName = this._model.platformName;

        this._messageContainer.innerHTML = `Are you sure you want to remove the image:<br><br>${imageName}<br><br>from the IoT Platform:<br><br>${platformName}`;

        this._checkboxContainer = document.createElement("div");
        this._checkboxContainer.classList.add("delete-image-checkbox-container");

        this._checkbox = new CheckboxControl({
            darkTheme: true,
            labelShown: true,
            label: "Also remove this Image from other IoT Platforms",
            title: "Also remove this Image from other IoT Platforms",
        });

        this._cancelButton = new ButtonControl({
            label: "Cancel",
            darkTheme: true,
            theme: "text",
        });

        this._confirmButton = new ButtonControl({
            label: "Confirm",
            darkTheme: true,
            theme: "destructive",
        });

        this._buttonContainer = document.createElement("button-container");

        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._cancelButton.on(
            "UserClick",
            (this._onCancelButtonClick = this._onCancelButtonClick.bind(this))
        );
        this._confirmButton.on(
            "UserClick",
            (this._onConfirmButtonClick = this._onConfirmButtonClick.bind(this))
        );
        this._checkbox.on(
            "UserValue",
            (this._onCheckboxChange = this._onCheckboxChange.bind(this))
        );
    }

    _unregisterListeners() {
        this._cancelButton.removeAllListeners("UserClick");
        this._confirmButton.removeAllListeners("UserClick");
        this._checkbox.removeAllListeners("UserValue");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
        let promArr = [
            this._checkbox.shutdown(),
            this._cancelButton.shutdown(),
            this._confirmButton.shutdown(),
        ];

        return Promise.all(promArr).then(
            () => {
                this._checkbox = undefined;
                this._cancelButton = undefined;
                this._confirmButton = undefined;
                this._checkboxContainer.remove();
                this._checkboxContainer = undefined;
                this._buttonContainer.remove();
                this._buttonContainer = undefined;
                this._messageContainer.remove();
                this._messageContainer = undefined;
                this._titleComponent.remove();
                this._titleComponent = undefined;
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
            },
            (err) => {
                if (this._model && this._model.logger) {
                    this._model.logger.warn(err, "DeleteImageRenderer.shutdown() error");
                }
            }
        );
    }

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     */
    render() {
        return new Promise((resolve) => {
            if (!this._rootElem.hasChildNodes()) {
                this._rootElem.appendChild(this._titleComponent);
                this._rootElem.appendChild(this._messageContainer);
                this._rootElem.appendChild(this._checkboxContainer);
                this._checkboxContainer.appendChild(this._checkbox.renderer.rootElement);
                this._rootElem.appendChild(this._buttonContainer);
                this._buttonContainer.appendChild(this._cancelButton.renderer.rootElement);
                this._buttonContainer.appendChild(this._confirmButton.renderer.rootElement);
            }
            resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onCancelButtonClick() {
        this.model.cancelAction();
    }

    _onConfirmButtonClick() {
        this._model.confirmAction();
    }

    _onCheckboxChange(value) {
        this._model.setCheckboxValue(value);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /*******************************************/
}

module.exports = DeleteImageRenderer;
